import React from 'react';
import CalculusOfMercy from '../components/CalculusOfMercy';

function CalculusOfMercyPage() {
  return <CalculusOfMercy />;
}

export default CalculusOfMercyPage;
